import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  // ESTADOS_CONTRATO_CHOICE,
  EstadosContratoChoiceEnum,
  // a11yProps,
  gridSizeMdLg1,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg6,
  useCheckPermissions,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
  // useTabsFormOnly,
} from '@/shared';
import { useFetchContratos } from '@/shared/actions/erp';
import {
  CustomAutocompleteArrString,
  // FormTabsOnly,
  GeneralTable,
  SingleIconButton,
  // TabsFormBoxScene,
} from '@/shared/components/ui';
import { Contrato, ESTADOS_INFO_CONTRATO_CHOICE, EstadosActualizacionContratoEnum } from '@/shared/interfaces';
// import { useState } from 'react';
import { useColumnsClientesSupervisionVentas } from '../../columns/useColumnsClientesSupervisionVentas';

interface ClientesRadioSupervisionVentasProps {
}
type FormDataClientes = {
  contratoState: EstadosContratoChoiceEnum;
  estadoInformacionContrato: EstadosActualizacionContratoEnum;
};

const ClientesRadioSupervisionVentas = ({ }: ClientesRadioSupervisionVentasProps) => {
  useCheckPermissions(PermissionsEnum.api_view_contrato);

  // const setAlert = useUiStore(s => s.setAlert);


  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  // const { handleMethodChange, valueTab } = useTabsFormOnly({
  //   initialTabValue: 1,
  // });

  const {
    // globalFilter,
    pagination,
    searchTerm,
    // onChangeFilter,
    setPagination,
    // cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  // const [openGenerateReport, setOpenGenerateReport] = useState(false);

  ///* form ---------------------------
  const form = useForm<FormDataClientes>({
    defaultValues: {
      contratoState: EstadosContratoChoiceEnum.ALL,
      estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    },
  });
  const { errors } = form.formState;

  const watchedContratoState = form.watch('contratoState');
  const watchedContratoInfoState = form.watch('estadoInformacionContrato');

  ///* fetch data ---------------------------
  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    enabled: !!watchedContratoState,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,

      ...(watchedContratoState !== EstadosContratoChoiceEnum.ALL && {
        //estado_contrato: watchedContratoState,
        //MANDO AQUI SOLO LOS QUE ESTAN EN SUSPENDIDO
      }),
      ...(watchedContratoInfoState !== EstadosActualizacionContratoEnum.ALL && {
        estado_actualizacion:
          watchedContratoInfoState == EstadosActualizacionContratoEnum.PENDIENTE_REVISION ?
            "ACTUALIZADO"
            : watchedContratoInfoState == EstadosActualizacionContratoEnum.APROBADO ?
              "REVISADO"
              : watchedContratoInfoState,
      }),
      tipo_servicio: "RADIO",
      preventa_estado_aceptacion: true,
      // estado_aceptacion:true,
      estado_contrato: EstadosContratoChoiceEnum.SUSPENDIDO,
      ...filterObject,
    },
  });


  ///* columns ---------------------------
  const { clientesFibraColumns } = useColumnsClientesSupervisionVentas();

  ///* effects ---------------------------
  useLoaders(isLoadingContratos || isRefetchingContratos);

  return (
    <>
      <Grid item container {...gridSizeMdLg12}>

        <Grid container spacing={1} direction={"row"} {...gridSizeMdLg6} sx={{ marginY: 1 }}>
          <CustomAutocompleteArrString
            size={gridSizeMdLg10}
            label="Estado Contrato"
            name="estadoInformacionContrato"
            control={form.control}
            defaultValue={
              form.getValues().estadoInformacionContrato ||
              EstadosActualizacionContratoEnum.ALL
            }
            options={ESTADOS_INFO_CONTRATO_CHOICE}
            isLoadingData={false}
            error={errors.estadoInformacionContrato}
            helperText={errors.estadoInformacionContrato?.message}
            disableClearable
          />
          <SingleIconButton
            size={gridSizeMdLg1}
            startIcon={<FilterAltOffIcon />}
            onClick={() => {
              form.setValue(
                'estadoInformacionContrato',
                EstadosActualizacionContratoEnum.ALL
              );
            }}
          />
        </Grid>
        <GeneralTable<Contrato>
          columns={clientesFibraColumns}
          data={contratosPagingRes?.data?.data || []}
          //
          isLoading={isLoadingContratos}
          isRefetching={isRefetchingContratos}
          // // filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={contratosPagingRes?.data?.count}
          // // actions ========
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
        />
      </Grid>
    </>
  );

}

export default ClientesRadioSupervisionVentas;